import Rest from '../Rest'

export default class StudentService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/students'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

}
